import React from "react";
// import Games from "./Games";
import Song from "./Song";

const HomePage: React.FC = () => {
  return (
    <div>
      {/* <section id="contact-form">
          <Games  />
        </section> */}

         <section id="contact-form">
          <Song />
        </section>
    </div> 
  );
};

export default HomePage;
